import type { AnyNode } from '@/types/nodes'

export type ResolveNodeLabelResult =
  | { kind: 'none' }
  | { kind: 'one'; node: AnyNode }
  | { kind: 'many'; candidates: AnyNode[] }

function norm(s: string) {
  return s.trim().toLowerCase()
}

function dedupeById(nodes: AnyNode[]): AnyNode[] {
  const seen = new Set<string>()
  return nodes.filter((n) => {
    if (seen.has(n.id)) return false
    seen.add(n.id)
    return true
  })
}

/**
 * Resuelve una etiqueta humana contra `node.nombre` (insensible a mayúsculas).
 * Varias coincidencias devuelven `many` para que el usuario elija en un select.
 */
export function resolveNodeLabel(label: string, nodes: AnyNode[]): ResolveNodeLabelResult {
  const q = norm(label)
  if (!q) return { kind: 'none' }

  const withName = nodes.filter((n) => n.nombre?.trim())
  const exact = withName.filter((n) => norm(n.nombre!) === q)
  if (exact.length === 1) return { kind: 'one', node: exact[0] }
  if (exact.length > 1) return { kind: 'many', candidates: exact }

  // Solo name.includes(q): evita que una consulta larga ("nap centro 001") coincida
  // por error con un nombre más corto ("nap centro") vía q.includes(name).
  const loose = dedupeById(
    withName.filter((n) => {
      const name = norm(n.nombre!)
      return name.includes(q)
    })
  )
  if (loose.length === 1) return { kind: 'one', node: loose[0] }
  if (loose.length > 1) return { kind: 'many', candidates: loose }

  return { kind: 'none' }
}

/** Nodos ordenados para desplegable manual (nombre + tipo). */
export function nodesForManualPick(allNodes: AnyNode[]): AnyNode[] {
  return [...allNodes].sort((a, b) => {
    const an = [a.nombre, a.tipo, a.id].filter(Boolean).join(' ')
    const bn = [b.nombre, b.tipo, b.id].filter(Boolean).join(' ')
    return an.localeCompare(bn, undefined, { sensitivity: 'base' })
  })
}
